import { useRef } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import isEqual from 'react-fast-compare';

export const objectToSelectOptions = (input) =>
  Object.keys(input)
    .map((value) => ({
      value,
      label: input[value],
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

/**
 * Courtesy of react-context-form project.
 * @param value
 * @returns {undefined}
 */
export function useIsEqualMemoize(value) {
  const ref = useRef();

  if (!isEqual(value, ref.current)) {
    ref.current = value;
  }

  return ref.current;
}

export const getIdFromSlug = (slug) => {
  const [id] = slug.match(/([0-9]+)$/g) || [null];

  return id;
};

export const slugify = (str) => {
  return (
    str
      .toLowerCase()
      // eslint-disable-next-line no-useless-escape
      .replace(/[\s_/\]\[]/g, '-')
      .replace(/[^A-Za-z0-9\-_]+/gi, '')
      .replace(/-+/gi, '-')
  );
};

export const getJobSlug = (id, title) => {
  const titleSlug = slugify(title);

  return `${titleSlug}-${id}`;
};

export const nl2br = (string) => `${string}`.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br />$2');

/**
 *
 * @param {*} params
 * @return "key1=value1&key2=value2&key3=value3"
 */
export const createQueryParamsFromObject = (params) =>
  Object.keys(params)
    .map((key) => `${key}=${encodeURIComponent(params[key])}`)
    .join('&');

export const getLocalizeUrl = (url, locale) => {
  if (!url) return '/';

  return !locale || locale === 'en_US' ? url : `/${locale}${url}`;
};

export const getLegalCopyKey = (applicationType, locale) => {
  if (locale && locale.toLowerCase().replace('_', '-') === 'tr-tr') {
    return 'AcknowledgmentCopyTR';
  }

  if (['002', '003', '007'].includes(applicationType)) {
    return 'AcknowledgmentCopyUS';
  }

  return 'AcknowledgmentCopyGlobal';
};

/**
 * Check if email is Tesla internal email
 * @param email
 * @return boolean
 */
export const isInternalEmail = (email) => {
  return email.toLowerCase().includes('@tesla.com');
};

// Check if is CN domain
export const isCNDomain = () => {
  return window.location.origin.includes('tesla.cn');
};

// CN only event tracking function
export const gioTrack = (eventKey, data = {}) => {
  if (typeof gdp !== 'undefined') {
    // eslint-disable-next-line
    gdp('track', eventKey, data);
  }
};
